module.exports = __webpack_public_path__ + "img/ustp-blue-logo.9fbb4082.png";